module.exports = __webpack_public_path__ + "img/join-9.4beac143.png";